module.exports = __webpack_public_path__ + "static/media/host.aca3f605.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/host.jpg
// module id = 159
// module chunks = 0